import React from 'react';

const StatusRibbon = () => (
  <div className="absolute -top-2 right-0 h-32 w-32 overflow-hidden z-10">
    <div className="bg-amber-200/90 text-amber-900 py-2 px-8 text-xs font-medium tracking-wider
                    absolute transform rotate-45 translate-y-6 translate-x-8
                    text-center shadow-md">
      PLANNING
    </div>
  </div>
);

export default StatusRibbon;